import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../redux/store";
import { useSelector } from "react-redux";
import { getPostReportList } from "../redux/Reducers/postReportsReducer";
import { getBlocks } from "../redux/Reducers/blocksReducer";
import { T } from "react-translator-component";
import LoadingModal from "../components/LoadingModal";
import SearchBar from "../components/Phase2/Searchbar";
import PostCard from "../components/lists/PostCard";
import RankingHeader from "../components/Phase2/RankingHeader";
import appServices from "../services/app-services/appServices";
import authService from "../services/app-services/auth-service";
import { loginWithToken } from "../redux/Reducers/userAuthReducer";
import MebukuIdUpgradeBanner from "../components/MebukuIdUpgradeBanner";
import { ErrorMessageModal } from "../components/ErrorMessageModal";
import PersonalInfoPopup from "../components/Models/PersonalInfoPopup";
import { getPersonalBasicInfo } from "../util/PortalAppFunction";
import { isRegularAppUser } from "../util/utils"

export default function VotingSeeMorePage() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { user } = useSelector((state: any) => state.userAuth);
  const { isSuccess: isSuccessGetPostReports } = useSelector((state: any) => state.postReports);
  const { isSuccess: isSuccessGetBlocks } = useSelector((state: any) => state.blocks);
  const [posts, setPosts] = useState<any[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [infoPopUp, setInfoPopUp] = useState<boolean>(false);
  const [showErrorModal, setShowErrorModal] = useState<boolean>(false);
  const [errMsg, setErrMsg] = useState<string[]>([]);

  const message = `${T("personal_info_popup_message")}`

  const getPersonalBI = () => {
    if (!isRegularAppUser(user)) return;
    getPersonalBasicInfo();
  };

  const portalAppGetPersonalBasicInfoCallBack = (event: MessageEvent): void => {
    if (!event?.data || event.data.source !== "portalAppGetPersonalBasicInfoCallBack" || !event.data.result) {
      return
    }
    let value = event.data.result
    try {
      if (typeof value === "string" || value instanceof String) {
        value = JSON.parse(value.replace(/"\{/g, '{').replace(/\}"/g, '}'))
      }

      if (Number(value?.result_code) !== 200) return

      const body = {
        name: value?.name,
        dob: value?.birthday,
        address: value?.address,
      };

      updateUser(body);
    } catch (error) {
      // pass
    }
  };

  const updateUser = async (body: any) => {
    try {
      await authService.updateAppUser(user.id, body);
      dispatch(loginWithToken(user?.auth_token));
    } catch (error) {
      // pass
    }
  };

  const getTopPosts = async () => {
    try {
      setIsLoading(true)
      const res = await appServices.getTopPosts();
      setPosts(res.posts)
    } catch (error: any) {
      setShowErrorModal(true)
      setErrMsg([error?.response?.data?.message ?? T("api_unknown_error")])
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (!dispatch || !user) return;

    if (!isSuccessGetPostReports) dispatch(getPostReportList())
    if (!isSuccessGetBlocks) dispatch(getBlocks(user.id))
    getTopPosts()

    window.addEventListener("message", portalAppGetPersonalBasicInfoCallBack);

    const isRequestUserPersonalInfo = (!user.name || !user.address || !user.dob);
    if (user.tutorial_completed_at) {
      if (isRequestUserPersonalInfo) {
        setTimeout(() => {
          getPersonalBI();
        }, 100);
      }
    } else {
      setInfoPopUp(true);
    }

    return () => {
      window.removeEventListener("message", portalAppGetPersonalBasicInfoCallBack);
    };
    // eslint-disable-next-line
  }, []);

  const completeTutorial = () => {
    const isRequestUserPersonalInfo = (!user.name || !user.address || !user.dob);
    if (isRequestUserPersonalInfo) {
      getPersonalBI();
    }
    updateUser({is_tutorial_completed: true});
    setInfoPopUp(false);
  }

  return (
    <div style={{ marginTop: 80, overflow: "scroll" }}>
      <LoadingModal visible={isLoading} />

      <div
        style={{
          paddingBottom: 10,
          borderBottom: "2px solid #86BB57",
        }}
      >
        <div
          onClick={() => navigate("/search")}
          style={{
            margin: "20px",
          }}
        >
          <SearchBar reSearch={false} onSearch={() => {}} />
        </div>
      </div>
      <div
        style={{
          paddingTop: 16,
          display: "flex",
          margin: "0 20px",
        }}
      >
        <RankingHeader />
      </div>

      <PersonalInfoPopup
        open={infoPopUp}
        message={message}
        nextText={T("next")}
        onClose={() => {
          setInfoPopUp(false);
        }}
        onNext={completeTutorial}
      />
      {posts.map((item: any, index: number) => (
        <PostCard
          post={item}
          showRanking
          showPostMenu={true}
          rank={index + 1}
          key={index}
        />
      ))}

      <MebukuIdUpgradeBanner />

      <ErrorMessageModal
        open={showErrorModal}
        messages={errMsg}
        onClose={() => setShowErrorModal(false)}
      />
    </div>
  );
}
